import * as Yup from "yup";

const RegisterSchema = Yup.object().shape({
  email: Yup.string().email().required("Enter a valid e-mail address"),
});

export default RegisterSchema;
